import { useState } from 'react';

const useDescriptionToggle = () => {
  const [expandedDescriptions, setExpandedDescriptions] = useState({});

  const toggleDescription = (index) => {
    setExpandedDescriptions(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

  return {
    expandedDescriptions,
    toggleDescription
  };
};

export default useDescriptionToggle;